import axios, { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';

import { ResponseList } from 'models/Response';
import { TypeMaster } from 'models/type/TypeMaster';

export function useWorkflowTypeMaster() {
    return useQuery({
        queryKey: ['workflow-type-master', { sid: '*' }],
        queryFn: ({ signal }) => {
            const accessToken = localStorage.getItem('WF_APPLICATION');

            return axios.get<ResponseList<TypeMaster>>(
                '/v2/configuration/workflow/type',
                {
                    signal,
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    },
                    params: {
                        sid: '*'
                    }
                }
            );
        },
        select: (response: AxiosResponse<ResponseList<TypeMaster>>) =>
            response.data.result_list,
        retry: 1,
        refetchOnWindowFocus: false
    });
}
